<ngx-extended-pdf-viewer
  *ngIf="base64"
  [base64Src]="base64"
  backgroundColor="#ffffff"
  [height]="'90vh'"
  [useBrowserLocale]="true"
  [handTool]="false"
  [showHandToolButton]="true"
>
</ngx-extended-pdf-viewer>
